/* eslint-disable react/jsx-no-bind */
import { Typography } from '@mui/material';
import React, { useContext, useState } from 'react';
import {
  MdDeleteOutline,
  MdDownload,
  MdEmail,
  MdPassword,
} from 'react-icons/md';
import GlobalContext from '../../../../../context/GlobalContext';
import api, { authHeader } from '../../../../../services/API/apiConfig';
import ToasterBox from '../../../../components/singleComponents/toaster/ToasterBox';
import InputLabelPassoword from '../../../../components/textInputs/InputLabelPassword/InputLabelPassword';
import { BtnCancelStyled, BtnSubmitStyled, LinksStyled } from './About.styles';

export function About() {
  const { userData } = useContext(GlobalContext);
  const user = userData || JSON.parse(localStorage.getItem('user'));
  const formData = false;

  const [oldPassword, setOldPassword] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');

  const [changePassword, setChangePassword] = useState(false);
  const [successSubmit, setSuccessSubmit] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorSubmit, setErrorSubmit] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  function handleChangePassword() {
    const data = JSON.stringify({
      user: {
        old_password: oldPassword,
        password,
        password_confirmation: passwordConfirmation,
      },
    });
    api
      .patch('/users/password', data, {
        headers: authHeader(formData),
      })
      .then((res) => {
        if (res.data.status === 0) {
          setSuccessMessage('Senha alterada com sucesso.');
          setSuccessSubmit(true);
          setChangePassword(false);
        } else {
          setErrorMessage(res.data.messages);
          setErrorSubmit(true);
        }
      });
  }

  return (
    <div style={{ padding: 15, marginLeft: 10 }}>
      {successSubmit && <ToasterBox message={successMessage} />}
      {errorSubmit && <ToasterBox message={errorMessage} />}
      {changePassword ? (
        <>
          <Typography variant="h2">Alterar Senha</Typography>
          <InputLabelPassoword
            label="Senha antiga"
            style={{ marginTop: 32 }}
            slotProps={{
              inputLabel: { shrink: true },
            }}
            onChange={(e) => setOldPassword(e.target.value)}
          />
          <div style={{ marginTop: 16 }}>
            <InputLabelPassoword
              label="Nova senha"
              style={{ marginRight: 16 }}
              slotProps={{
                inputLabel: { shrink: true },
              }}
              onChange={(e) => setPassword(e.target.value)}
            />
            <InputLabelPassoword
              label="Confirmação de senha"
              slotProps={{
                inputLabel: { shrink: true },
              }}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div />
            <div
              style={{
                display: 'flex',
                gap: 32,
                marginTop: 32,
                marginRight: 16,
              }}
            >
              <BtnSubmitStyled
                variant="contained"
                onClick={handleChangePassword}
              >
                Alterar senha
              </BtnSubmitStyled>
              <BtnCancelStyled
                variant="contained"
                onClick={() => setChangePassword(!changePassword)}
              >
                Cancelar
              </BtnCancelStyled>
            </div>
          </div>
        </>
      ) : (
        <>
          <LinksStyled>
            <MdEmail size={24} />
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <Typography variant="h5">Email</Typography>
              {' - '}
              <Typography variant="body1">{user.email}</Typography>
            </div>
          </LinksStyled>
          <LinksStyled onClick={() => setChangePassword(!changePassword)}>
            <MdPassword size={24} />
            <Typography variant="h5">Alterar senha</Typography>
          </LinksStyled>
          <LinksStyled>
            <MdDownload size={24} />
            <Typography variant="h5">Baixar meus dados</Typography>
          </LinksStyled>
          <LinksStyled>
            <MdDeleteOutline size={24} />
            <Typography variant="h5">Excluir conta</Typography>
          </LinksStyled>
        </>
      )}
    </div>
  );
}
